import React from "react";
import { cls } from "@wss/cls";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import LoginLink from "./LoginLink";
import { Price } from "~/common/Store/models/ProductListing";
const getMAPOversizedPriceClass = (oversizedPrice: number, type: string) => {
  if (["D", "G", "H", "N", "S"].includes(type)) {
    if (oversizedPrice >= 10000) {
      return "text-lg lg:text-xl";
    }
  }
  return "text-lg";
};
interface AddToCartToSeePriceProps {
  mapPrice: number;
  type: string;
  price: Price;
  priceCrossedOut?: boolean;
  showDiscount?: boolean;
  showEnticement?: boolean;
  showLoginLink: boolean;
  productListingView?: string;
}
const AddToCartToSeePrice = ({
  mapPrice,
  type,
  price,
  priceCrossedOut,
  showDiscount,
  showEnticement,
  showLoginLink,
  productListingView
}: Readonly<AddToCartToSeePriceProps>) => <>
    <div className={cls("bg-white", "border-red-500", "rounded", "border-solid", "border", "block", "leading-none", "-mb-1", "p-2", productListingView === "list" ? "my-0 max-w-full w-40 xs:mx-auto xs:text-center" : "text-center")}>
      {showLoginLink ? <LoginLink disableDefaultStyles>
          {showDiscount && <DiscountText price={price.price} mapPrice={mapPrice} />}
          <p className="text-xs leading-none mb-0 text-gray-800">
            <strong>Add to cart</strong>
            {" or "}
            <span className="text-green-500 hover:text-green-900">login</span>
            {" to see our "}
            price!
          </p>
          {showEnticement && <EnticementText mapPrice={mapPrice} type={type} productListingView={productListingView} />}
        </LoginLink> : <>
          {showDiscount && <DiscountText price={price.price} mapPrice={mapPrice} />}
          <p className="text-xs leading-none mb-0 text-gray-800">
            <strong>Add to cart </strong>
            to see our price!
          </p>
          {showEnticement && <EnticementText mapPrice={mapPrice} type={type} productListingView={productListingView} />}
        </>}
    </div>

    <div className="p-0 relative">
      <p className={cls("inline-block", "font-semibold", "text-base", "leading-none", "m-0", "mt-1", "p-0", "text-center", "text-red-500", "xs:inline", "xs:text-xs", "xs:mt-0")}>
        <span className={cls("inline", "font-semibold", "text-xs", "leading-4", "p-0", "text-gray-800")}>
          Retail Price{" "}
        </span>
        <span className={priceCrossedOut ? "line-through" : ""}>
          {formatAsCurrency.formatIfUndefined(price.price)}
        </span>
      </p>
    </div>
  </>;
interface EnticementTextProps {
  mapPrice: number;
  type: string;
  productListingView?: string;
}
const getHiddenPrice = (mapPrice: number) => {
  return `${formatAsCurrency.formatIfUndefined(mapPrice).toString().replace(/[0-9]/g, "X")}`;
};
function EnticementText({
  mapPrice,
  type,
  productListingView
}: Readonly<EnticementTextProps>) {
  return <p data-testid="text-enticement" className={cls("font-semibold", "leading-none", "m-0", "p-0", "text-red-500", productListingView === "list" ? "xs:text-center" : "text-center", getMAPOversizedPriceClass(mapPrice, type))} data-sentry-component="EnticementText" data-sentry-source-file="AddToCartToSeePrice.tsx">
      {getHiddenPrice(mapPrice)}
    </p>;
}
interface DiscountTextProps {
  price: number;
  mapPrice: number;
}
function DiscountText({
  price,
  mapPrice
}: Readonly<DiscountTextProps>) {
  return <p className="font-semibold text-lg mb-0 text-gray-800" data-sentry-component="DiscountText" data-sentry-source-file="AddToCartToSeePrice.tsx">
      {"Save "}
      <span className="font-semibold text-red-500">
        {formatAsCurrency.formatIfUndefined(price - mapPrice)}
      </span>
    </p>;
}
export default AddToCartToSeePrice;